var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useManageWorkplaceServiceRequest } from '../../../../hooks/useManageWorkplaceServiceRequest';
import { useConfig } from '../../../../context/ConfigContext';
var Context = React.createContext({
    workplaceServiceFormRequest: undefined,
    workplaceServicesEnabled: false,
    iframePath: '',
    onSuccessfulRequest: function () { return null; },
    onAddWorkplaceServiceRequest: function () { return null; },
    serviceRequestFormStatus: undefined,
    onCloseIframe: function () { return null; },
    onSubmitIframe: function () { return null; },
    handleWorkplaceServiceError: function () { return null; },
    editingEvent: false,
});
export var WorkplaceServiceRequestProvider = function (_a) {
    var onSuccessfulRequest = _a.onSuccessfulRequest, onAddWorkplaceServiceRequest = _a.onAddWorkplaceServiceRequest, serviceRequestFormStatus = _a.serviceRequestFormStatus, onCloseIframe = _a.onCloseIframe, onSubmitIframe = _a.onSubmitIframe, handleWorkplaceServiceError = _a.handleWorkplaceServiceError, children = _a.children, editingEvent = _a.editingEvent, props = __rest(_a, ["onSuccessfulRequest", "onAddWorkplaceServiceRequest", "serviceRequestFormStatus", "onCloseIframe", "onSubmitIframe", "handleWorkplaceServiceError", "children", "editingEvent"]);
    var userContext = useConfig().userContext;
    var currentUser = userContext.currentUser;
    var _b = useManageWorkplaceServiceRequest(serviceRequestFormStatus), workplaceServicesEnabled = _b.workplaceServicesEnabled, iframePath = _b.iframePath;
    if (!currentUser) {
        return null;
    }
    var workplaceServiceFormRequest = __assign({ userId: currentUser.id, formAction: serviceRequestFormStatus }, props);
    return (_jsx(Context.Provider, { value: {
            workplaceServiceFormRequest: workplaceServiceFormRequest,
            workplaceServicesEnabled: workplaceServicesEnabled,
            iframePath: iframePath,
            onSuccessfulRequest: onSuccessfulRequest,
            onAddWorkplaceServiceRequest: onAddWorkplaceServiceRequest,
            serviceRequestFormStatus: serviceRequestFormStatus,
            onCloseIframe: onCloseIframe,
            onSubmitIframe: onSubmitIframe,
            handleWorkplaceServiceError: handleWorkplaceServiceError,
            editingEvent: editingEvent,
        }, children: children }));
};
export function useWorkplaceServiceRequestContext() {
    return useContext(Context);
}
